/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Details_Failed_LoadInputs */



/**
* | output |
* | --- |
* | "Failed to load log details" |
*
* @param {Audit_Logs_Details_Failed_LoadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_details_failed_load = /** @type {((inputs?: Audit_Logs_Details_Failed_LoadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Details_Failed_LoadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Laden der Protokolldetails")
	return /** @type {LocalizedString} */ ("Failed to load log details")
});